import React from 'react';
import { Link } from 'react-router-dom';
import classesForm from '../Form.module.scss';
import { GeneralContext } from '../../../context/generalContext';

export default function MessageModal({ showMessage, showErrorMessage, showOffMessage, closeMessage, message }) {
  const { activeLanguage, setActiveMenuItem, activeCity } = React.useContext(GeneralContext);

  const goToMain = () => {
    closeMessage();
    setActiveMenuItem();
    window.scrollTo(0, 0);
  };

  const goBack = () => {
    closeMessage();
    window.scrollTo(0, 0);
  };

  return (
    <div
      className={`${classesForm.msgModal} ${classesForm.msgSubmitModal}`}
      data-show={showMessage || showOffMessage || showErrorMessage ? 'true' : 'false'}
    >
      <div className={`${classesForm.msgModalBox} ${classesForm.msgSubmitModalBox}`}>
        <div className={classesForm.msgModalContent}>
          {showMessage && (
            <>
              <div
                className={classesForm.msgModalTitle}
                dangerouslySetInnerHTML={{
                  __html: activeLanguage === 1 ? message.title : message.title_en || message.title,
                }}
              />
              <div className={classesForm.msgModalInfo}>
                {activeCity === 6 && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        activeLanguage === 1 ? message.textTashkent : message.textTashkent_en || message.textTashkent,
                    }}
                  />
                )}
                {activeCity !== 6 && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: activeLanguage === 1 ? message.text : message.text_en || message.text,
                    }}
                  />
                )}

                <div className={classesForm.msgModalBtnBox}>
                  <Link className={classesForm.msgModalBtn} to={activeLanguage === 1 ? '/' : '/en/'} onClick={goToMain}>
                    {activeLanguage === 1 ? 'Вернуться на главную' : 'Go back to the main page'}
                  </Link>
                </div>
              </div>
            </>
          )}
          {showErrorMessage && (
            <>
              <div
                className={classesForm.msgModalInfo}
                dangerouslySetInnerHTML={{
                  __html: activeLanguage === 1 ? message.errorText : message.errorText_en || message.errorText,
                }}
              />

              <div className={classesForm.msgModalBtnBox}>
                <div
                  className={classesForm.msgModalBtn}
                  // to={activeLanguage === 1 ? '/' : '/en/'}
                  onClick={goBack}
                >
                  {activeLanguage === 1 ? 'Вернуться' : 'Go back'}
                </div>
              </div>
            </>
          )}
          {showOffMessage && (
            <>
              <div
                className={classesForm.msgModalTitle}
                dangerouslySetInnerHTML={{
                  __html: activeLanguage === 1 ? message.offTitle : message.offTitle_en || message.offTitle,
                }}
              />
              <div className={classesForm.msgModalInfo}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: activeLanguage === 1 ? message.offText : message.offText_en || message.offText,
                  }}
                />

                <div className={classesForm.msgModalBtnBox}>
                  <Link className={classesForm.msgModalBtn} to={activeLanguage === 1 ? '/' : '/en/'} onClick={goToMain}>
                    {activeLanguage === 1 ? 'Вернуться на главную' : 'Go back to the main page'}
                  </Link>
                </div>
              </div>
            </>
          )}
          <button className={classesForm.msgModalCloser} onClick={closeMessage} />
        </div>
      </div>
      <div className={classesForm.msgModalOverlay} onClick={closeMessage} />
    </div>
  );
}
